export const COSTCODE_FORM_RULES = {
  codeMaxLength: 30,
};

export default {};
